<template>
  <div class="lock">
    <div class="list-right">
      <el-table
        v-loading="tableLoading"
        element-loading-text="数据加载中..."
        ref="table"
        border
        :data="tableListData.rows"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        height="100%"
        v-if="tableListData.rows && tableListData.rows.length > 0"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="所属集团" prop="deptName" min-width="140"></el-table-column>
        <el-table-column label="锁编号" prop="lockCode" min-width="120"></el-table-column>
        <el-table-column label="设备类型" prop="deviceType" min-width="120"></el-table-column>
        <el-table-column label="通讯类型" prop="commType" min-width="100"></el-table-column>
        <el-table-column label="泊位编号" prop="spaceNum" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.spaceNum === '未绑定' || !scope.row.spaceNum" class="tag-unbind">未绑定</span>
            <span v-else>{{ scope.row.spaceNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属道路" prop="parkingName" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.parkingName === '未绑定' || !scope.row.parkingName" class="tag-unbind">未绑定</span>
            <span v-else>{{ scope.row.parkingName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="在线状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="getOnlineStatusType(scope.row.onlineStatus)" size="small">
              {{ scope.row.onlineStatus || '未知' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="锁状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="getLockStatusType(scope.row.lockStatus)" size="small">
              {{ formatLockStatus(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="异常信息" prop="exception" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.exception === '正常' ? 'success' : 'danger'" size="small">
              {{ scope.row.exception }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="告警信息" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.alarmInfo === '正常' || !scope.row.alarmInfo ? 'success' : 'danger'" size="small">
              {{ scope.row.alarmInfo || '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="挡板状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="getBaffleStatusType(scope.row.baffleStatus)" size="small">
              {{ scope.row.baffleStatus || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="挡板角度" prop="baffleAngle" min-width="100"></el-table-column>
        <el-table-column label="是否水淹" prop="isFlooded" min-width="100"></el-table-column>
        <el-table-column label="车位状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="getParkingStatusType(scope.row.parkingSpaceStatus)" size="small">
              {{ scope.row.parkingSpaceStatus || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="电压(V)" prop="voltage" min-width="100"></el-table-column>
        <el-table-column label="电量(%)" prop="power" min-width="100"></el-table-column>
        <el-table-column label="信号强度" prop="rssi" min-width="100"></el-table-column>
        <el-table-column label="软件版本" prop="lockVersions" min-width="100"></el-table-column>
        <el-table-column label="监测方式" prop="monitorType" min-width="120"></el-table-column>
        <el-table-column label="电池类型" prop="batteryType" min-width="120"></el-table-column>
        <el-table-column label="安装类型" prop="installType" min-width="100"></el-table-column>
        <el-table-column label="最后通讯时间" prop="finalTime" min-width="160"></el-table-column>
        <el-table-column label="操作" width="200px" fixed="right">
          <template slot-scope="scope">
            <button
              class="edit"
              type="button"
              @click="addOrEdit(scope.row)"
            >
              修改
            </button>
            <button
              class="delete"
              @click="del(scope.row.lockId)"
              type="button"
            >
              删除
            </button>
            <el-dropdown @command="handleCommand">
              <span
                style="
                  font-size: 12px;
                  color: #409eff;
                  margin-left: 4px;
                  cursor: pointer;
                "
              >
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
               
                  :command="{ type: 'up', ...scope.row }"
                  >升锁</el-dropdown-item
                >
                <el-dropdown-item
               
                  :command="{ type: 'down', ...scope.row }"
                  >降锁</el-dropdown-item
                >
                <el-dropdown-item :command="{ type: 'reset', ...scope.row }"
                  >复位</el-dropdown-item
                >
                <el-dropdown-item :command="{ type: 'restart', ...scope.row }"
                  >重启</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div
        v-else
        style="
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

        <!--添加/修改锁-->
        <el-dialog
          ref="park"
          :title="editOrAddForm.lockId ? '修改锁' : '添加锁'"
          :close-on-click-modal="false"
          :lock-scroll="false"
          :visible.sync="dialogFormVisible"
          width="500px"
          @open="openDialog"
          @close="closeDialog"
          class="dialog-lock"
        >
          <el-form
            :model="editOrAddForm"
            :rules="editOrAddFormRules"
            ref="editOrAddFormV"
          >
            <el-form-item
              label="锁编号"
              :label-width="formLabelWidth"
              prop="lockCode"
            >
              <el-col :span="18">
                <el-input v-model="editOrAddForm.lockCode" placeholder="请输入锁编号"></el-input>
              </el-col>
            </el-form-item>
            <!-- <el-form-item
              label="锁体类型"
              :label-width="formLabelWidth"
              prop="lockBodyType"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.lockBodyType" placeholder="请选择锁体类型" style="width: 100%;">
                  <el-option label="A型平板锁(ZG)" value="A型平板锁(ZG)"></el-option>
                  <el-option label="B型平板锁" value="B型平板锁"></el-option>
                  <el-option label="C型平板锁(HM)" value="C型平板锁(HM)"></el-option>
                  <el-option label="D型平板锁(DT)" value="D型平板锁(DT)"></el-option>
                  <el-option label="E型平板锁(UB)" value="E型平板锁(UB)"></el-option>
                  <el-option label="F型占位锁(GZ)" value="F型占位锁(GZ)"></el-option>
                  <el-option label="G型占位锁(BZB)" value="G型占位锁(BZB)"></el-option>
                  <el-option label="H型平板锁(ZK)" value="H型平板锁(ZK)"></el-option>
                  <el-option label="K型占位锁(XY)" value="K型占位锁(XY)"></el-option>
                </el-select>
              </el-col>
            </el-form-item> -->
            <el-form-item
              label="通讯类型"
              :label-width="formLabelWidth"
              prop="communicationType"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.communicationType" placeholder="请选择通讯类型" style="width: 100%;">
                  <el-option label="4G" value="4G"></el-option>
                  <el-option label="LORA&基站" value="LORA&基站"></el-option>
                  <el-option label="NB-IOT" value="NB-IOT"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="检测方式"
              :label-width="formLabelWidth"
              prop="detectionMethod"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.detectionMethod" placeholder="请选择检测方式" style="width: 100%;">
                  <el-option label="地磁+微波" value="地磁+微波"></el-option>
                  <el-option label="地感线圈" value="地感线圈"></el-option>
                  <el-option label="地磁微波+地感" value="地磁微波+地感"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="电池类型"
              :label-width="formLabelWidth"
              prop="batteryType"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.batteryType" placeholder="请选择电池类型" style="width: 100%;">
                  <el-option label="三元锂电池" value="三元锂电池"></el-option>
                  <el-option label="铅酸电池" value="铅酸电池"></el-option>
                  <el-option label="磷酸铁锂电池" value="磷酸铁锂电池"></el-option>
                  <el-option label="市电" value="市电"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="安装类型"
              :label-width="formLabelWidth"
              prop="installationType"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.installationType" placeholder="请选择安装类型" style="width: 100%;">
                  <el-option label="嵌入式" value="嵌入式"></el-option>
                  <el-option label="地面式" value="地面式"></el-option>
                  <el-option label="半嵌入式" value="半嵌入式"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="设备类型"
              :label-width="formLabelWidth"
              prop="lockType"
            >
              <el-col :span="18">
                <el-select v-model="editOrAddForm.lockType" placeholder="请选择设备类型" style="width: 100%;">
                  <el-option label="中置平板锁" value="中置平板锁"></el-option>
                  <el-option label="中置占位锁" value="中置占位锁"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  shareParks,
  locks,
  lockDetail,
  addLock,
  updateLock,
  deleteLock,
  upLock,
  downLock,
  resetLock,
  gatewaysByParkingId,
  nb4gLockPage,
  nb4gLockAdd,
  nb4gLockUpdate,
  nb4gLockDelete,
  nb4gLockOpen,
  nb4gLockClose,
  nb4gLockReset,
  nb4gLockRestart,
} from "@/api/url";

import Page from "@/page/commons/page";
import AreaTree from "@/page/commons/parking/commons/areaTree.vue";

export default {
  props: [
    "parkingId",
    "gatewayId",
    "lockCode",
    "spaceNum",
    "onlineStatus",
    "parkingSpaceStatus",
    "baffleStatus",
    "bindStatus",
    "isFlooded",
    "power",
  ],
  data() {
    return {
      dialogFormVisible: false,

      park: "",

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      editOrAddForm: {
        lockId: null,
        lockCode: "",
        lockBodyType: "",
        lockType: "",
        communicationType: "",
        detectionMethod: "",
        batteryType: "",
        installationType: "",
      },

      editOrAddFormRules: {
        lockCode: [
          { required: true, message: "请输入锁编号", trigger: "blur" }
        ],
        lockType: [],
      },
      formLabelWidth: "100px",
      allOrderType: [],
      moduleName: "",
      temp: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        devStatu: "",
        devNum: "",
        //transNum:'',
        //startTime:"",
        //endTime:""
      },
      downloadFileds: {
        地磁编号: "onerankdevDevSn",
        网关编号: {
          field: "attr7",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).stationSn
              : "";
          },
        },
        泊位编号: {
          field: "attr8",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).spaceNum
              : "";
          },
        },
        停车道路: {
          field: "attr2",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).parkingName
              : "";
          },
        },
        泊位段: {
          field: "attr3",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).areaName
              : "";
          },
        },
        最后通讯时间: "lastFlowDate",
        地磁状态: "attr1",
        通信频率: "loraid",
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      shareParksData: [],
      gateways: [],
      tableLoading: false,
      selectedRows: [], // 选中的行
    };
  },
  mounted() {
    console.log("list mounted");
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    params() {
      return {
        parkingId: this.parkingId || undefined,
        gatewayId: this.gatewayId || undefined,
      };
    },
  },

  watch: {
    // 搜索条件和道路变化不再自动触发查询，由父组件点击"查询"按钮时调用 handleSearch() 触发
  },
  mounted() {
    // 初始加载：组件挂载时查询一次
    this.tableList(1);
  },
  methods: {
    ...mapMutations(["getPage"]),
    // 锁状态格式化
    formatLockStatus(row) {
      const statusMap = {
        '00': '升降中',
        '10': '正常升起',
        '20': '正常降下',
        '22': '降锁休眠',
        '23': '临时降锁休眠',
        '24': '水淹降锁休眠',
        '1F': '升降遇阻后处于升起状态',
        '2F': '升降遇阻后处于降下状态',
        'FF': '异常',
      };
      const status = (row.lockStatus || '').replace(/^0x/, '').toUpperCase();
      return statusMap[status] || row.lockStatus || '-';
    },
    // 锁状态标签颜色
    getLockStatusType(lockStatus) {
      const status = (lockStatus || '').replace(/^0x/, '').toUpperCase();
      const typeMap = {
        '00': '',           // 升降中 -> 默认蓝
        '10': 'success',    // 正常升起 -> 绿色
        '20': '',           // 正常降下 -> 默认蓝
        '22': 'warning',    // 降锁休眠 -> 橙色
        '23': 'warning',    // 临时降锁休眠 -> 橙色
        '24': 'danger',     // 水淹降锁休眠 -> 红色
        '1F': 'warning',    // 升降遇阻后处于升起状态 -> 橙色
        '2F': 'warning',    // 升降遇阻后处于降下状态 -> 橙色
        'FF': 'danger',     // 异常 -> 红色
      };
      return typeMap[status] || 'info';
    },
    // 在线状态标签颜色
    getOnlineStatusType(status) {
      if (!status) return 'info';
      if (status === '在线') return 'success';
      if (status === '离线') return 'danger';
      if (status === '未知') return 'info';
      return 'info';
    },
    // 挡板状态标签颜色
    getBaffleStatusType(status) {
      if (!status) return 'info';
      if (status === '正常') return 'success';
      if (status === '异常') return 'danger';
      if (status === '未知') return 'info';
      return 'info';
    },
    // 车位状态标签颜色
    getParkingStatusType(status) {
      if (!status) return 'info';
      if (status === '无车') return 'success';
      if (status === '有车') return 'warning';
      return 'info';
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
      console.log("list", curPage);
      var _this = this;
      _this.tableListData.rows = [];
      _this.tableLoading = true;

      // 构建查询参数
      const params = {
        page: curPage,
        limit: this.search.pageSize,
      };
      
      // 如果提供了停车场ID，则添加到查询参数中
      if (this.parkingId) {
        params.parkingId = this.parkingId;
      }
      if (this.gatewayId) {
        params.gatewayId = this.gatewayId;
      }

      // 添加查询条件（从 props 获取）
      if (this.lockCode) {
        params.lockCode = this.lockCode;
      }
      if (this.spaceNum) {
        params.spaceNum = this.spaceNum;
      }
      if (this.onlineStatus) {
        params.onlineStatus = this.onlineStatus;
      }
      if (this.parkingSpaceStatus) {
        params.parkingSpaceStatus = this.parkingSpaceStatus;
      }
      if (this.baffleStatus) {
        params.baffleStatus = this.baffleStatus;
      }
      if (this.bindStatus) {
        params.bindStatus = this.bindStatus;
      }
      if (this.isFlooded) {
        params.isFlooded = this.isFlooded;
      }
      if (this.power) {
        params.power = this.power;
      }

      // 调用 NB4G 锁分页接口，返回 Promise
      return this.$get(nb4gLockPage(), params)
        .then((data) => {
          _this.tableLoading = false;
          if (data.status != 200) {
            _this.$message.error(data.message || "加载数据失败");
            return;
          }
          // 翻页
          var pageObj = {
            curIndex: data.data?.offset || curPage,
            rowsCount: data.data?.total || 0,
          };
          _this.getPage(pageObj);
          _this.tableListData.rows = data.data?.rows || [];

          _this.$nextTick(() => {
            if (_this.$refs.table) {
              _this.$refs.table.doLayout();
            }
          });
        })
        .catch((error) => {
          _this.tableLoading = false;
          console.error("加载数据失败:", error);
          if (error.response && error.response.status === 500) return;
        });
    },

    // 查询（供父组件调用）
    handleSearch() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },

    // 重置（供父组件调用）
    handleReset() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },

    addOrEdit(row) {
      this.dialogFormVisible = true;
      if (row && row.lockId) {
        // 修改模式：直接从列表行数据回显
        this.editOrAddForm = {
          lockId: row.lockId,
          lockCode: row.lockCode || "",
          lockBodyType: row.lockBodyType || "",
          lockType: row.deviceType || "",
          communicationType: row.commType || "",
          detectionMethod: row.monitorType || "",
          batteryType: row.batteryType || "",
          installationType: row.installType || "",
        };
      } else {
        // 添加模式
        this.editOrAddForm = {
          lockId: null,
          lockCode: "",
          lockBodyType: "",
          lockType: "",
          communicationType: "",
          detectionMethod: "",
          batteryType: "",
          installationType: "",
        };
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs["editOrAddFormV"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          
          const formData = {
            lockId: _this.editOrAddForm.lockId || undefined,
            lockCode: _this.editOrAddForm.lockCode,
            lockBodyType: _this.editOrAddForm.lockBodyType,
            deviceType: _this.editOrAddForm.lockType,
            commType: _this.editOrAddForm.communicationType,
            monitorType: _this.editOrAddForm.detectionMethod,
            batteryType: _this.editOrAddForm.batteryType,
            installType: _this.editOrAddForm.installationType,
          };
          
          if (_this.editOrAddForm.lockId) {
            // 修改模式 - PUT /api/parking/nb4gLock/{id}
            _this
              .$putRequest(nb4gLockUpdate(_this.editOrAddForm.lockId), formData)
              .then((data) => {
                if (data.status !== 200)
                  return _this.$message.error(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功！",
                  title: "成功",
                });
                _this.tableList(_this.curIndex);
                _this.$emit('operation-complete');
              });
          } else {
            // 添加模式 - POST /api/parking/nb4gLock
            _this
              .$postRequest(nb4gLockAdd(), formData)
              .then((data) => {
                if (data.status !== 200)
                  return _this.$message.error(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功！",
                  title: "成功",
                });
                _this.tableList(1);
                _this.$emit('operation-complete');
              });
          }
        }
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["editOrAddFormV"].resetFields();
    },
    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除该设备吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          // 删除模式 - DELETE /api/parking/nb4gLock/{id}
          _this.$deleteRequest(nb4gLockDelete(id)).then((data) => {
            if (data.status != 200) return _this.$message.error(data.message);

            _this.$notify({
              type: "success",
              message: "删除成功！",
              title: "成功",
            });
            _this.tableList(_this.curIndex);
            _this.$emit('operation-complete');
          });
        }
      );
    },
    //   handleTreeClick: function(node) {
    //     // 如果节点类型为停车场
    //     if (node.type === "parking") {
    //       this.search.parkingId = node.id;
    //       this.onParkChange(node.id);
    //       // 获取数据
    //       this.tableList(this.search.pageNumber);
    //     } else this.search.parkingId = undefined;
    //   },
    //   searchList: function() {
    //     if (this.tableLoading) return;
    //     if (!this.search.parkingId)
    //       return this.$message({ type: "error", message: "请先选择停车场" });
    //     this.search.pageNumber = 1;
    //     this.tableList(this.search.pageNumber);
    //   },

    //   getShareParks() {
    //     this.search.gatewayId = "";
    //     this.editOrAddForm.gatewayId = "";
    //     this.$postRequest(shareParks(), {}).then((data) => {
    //       this.shareParksData = data?.data?.data?.rows ?? [];
    //     });
    //   },
    async handleCommand(command) {
      console.log("command=>", command);
      const { type, lockCode } = command;
      var _this = this;

      const typeNameMap = {
        up: '升锁',
        down: '降锁',
        reset: '复位',
        restart: '重启',
      };
      const operationName = typeNameMap[type] || '操作';

      // 确认弹窗
      const confirmed = await new Promise((resolve) => {
        var index = _this.$layer.confirm(
          `您确定要对设备【${lockCode}】执行【${operationName}】操作吗？`,
          {
            btn: ["确定", "取消"],
            shade: false,
            type: 0,
          },
          function () {
            _this.$layer.close(index);
            resolve(true);
          },
          function () {
            _this.$layer.close(index);
            resolve(false);
          }
        );
      });
      if (!confirmed) return;

      const apiMap = {
        up: nb4gLockOpen(),
        down: nb4gLockClose(),
        reset: nb4gLockReset(),
        restart: nb4gLockRestart(),
      };

      const url = apiMap[type];
      if (!url) return;

      try {
        const res = await this.$post(url, { lockCode: lockCode });
        if (res.status === 200) {
          this.$message({ message: "操作成功", type: "success" });
          this.tableList(this.curIndex);
          this.$emit('operation-complete');
        } else {
          this.$message.error(res.message || "操作失败");
        }
      } catch (error) {
        console.error("操作失败:", error);
      }
    },
    //   getGateways(id) {
    //     this.$get(`${gatewaysByParkingId()}/${id}`).then((data) => {
    //       this.gateways = data?.data ?? [];
    //     });
    //   },
    //   onParkChange(val) {
    //     this.getGateways(val);
    //   },

    // 选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      // 通知父组件选中状态变化
      this.$emit('selection-change', selection);
    },
    // 批量操作（供父组件调用）
    batchOperate(type, lockCodes) {
      var _this = this;
      const typeMap = {
        open: 'up',
        close: 'down',
        reset: 'reset',
        restart: 'restart',
      };
      const typeNameMap = {
        up: '升锁',
        down: '降锁',
        reset: '复位',
        restart: '重启',
      };
      const mappedType = typeMap[type];
      if (!mappedType) return;

      const operationName = typeNameMap[mappedType] || '操作';
      const lockCodesStr = lockCodes.join('、');

      // 确认弹窗
      var index = _this.$layer.confirm(
        `您确定要对选中的 ${lockCodes.length} 个设备【${lockCodesStr}】执行【${operationName}】操作吗？`,
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          const apiMap = {
            up: nb4gLockOpen(),
            down: nb4gLockClose(),
            reset: nb4gLockReset(),
            restart: nb4gLockRestart(),
          };

          const url = apiMap[mappedType];
          if (!url) return;

          _this.$post(url, { lockCode: lockCodes.join(',') })
            .then((res) => {
              if (res.status === 200) {
                _this.$message({ message: "操作成功", type: "success" });
                _this.tableList(_this.curIndex);
                _this.$emit('operation-complete');
              } else {
                _this.$message.error(res.message || "操作失败");
              }
            })
            .catch((error) => {
              console.error("批量操作失败:", error);
            });
        }
      );
    },
  },

  components: {
    AreaTree,
  },
};
</script>

<style scoped>
/* @import '@/assets/css/equip.css'; */
.lock {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.btns {
  margin: 20px auto 0;
  width: 150px;
}

table td label {
  margin-bottom: 0 !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
.lock .form-control {
  height: 26px;
}

/* 未绑定标记 */
.tag-unbind {
  color: #f56c6c;
  font-style: italic;
}
</style>
<style>
.lock .list-right {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
  height: auto !important;
  padding-bottom: 0 !important;
}

.lock .list-right .el-table {
  flex: 1 !important;
  min-height: 0 !important;
  height: 100% !important;
}
</style>
